var _g, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBottomLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 414,
    height: 308,
    viewBox: "0 0 414 308",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1021_1310)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 39,
    cy: 337.5,
    rx: 185,
    ry: 184.5,
    fill: "url(#paint0_linear_1021_1310)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 131,
    width: 3.5469,
    height: 4.70646,
    rx: 1.77345,
    fill: "#EE4B63"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 200.775,
    width: 3.5469,
    height: 4.70646,
    rx: 1.77345,
    fill: "#EE4B63"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 154.258,
    width: 3.5469,
    height: 4.70646,
    rx: 1.77345,
    fill: "#EE4B63"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 224.035,
    width: 3.5469,
    height: 4.70646,
    rx: 1.77345,
    fill: "#EE4B63"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 177.518,
    width: 3.5469,
    height: 4.70646,
    rx: 1.77345,
    fill: "#EE4B63"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 247.293,
    width: 3.5469,
    height: 4.70646,
    rx: 1.77345,
    fill: "#EE4B63"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 131.227,
    y: 131,
    width: 3.5469,
    height: 4.70646,
    rx: 1.77345,
    fill: "#EE4B63"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 131.227,
    y: 200.775,
    width: 3.5469,
    height: 4.70646,
    rx: 1.77345,
    fill: "#EE4B63"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 131.227,
    y: 154.258,
    width: 3.5469,
    height: 4.70646,
    rx: 1.77345,
    fill: "#EE4B63"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 131.227,
    y: 224.035,
    width: 3.5469,
    height: 4.70646,
    rx: 1.77345,
    fill: "#EE4B63"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 131.227,
    y: 177.518,
    width: 3.5469,
    height: 4.70646,
    rx: 1.77345,
    fill: "#EE4B63"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 131.227,
    y: 247.293,
    width: 3.5469,
    height: 4.70646,
    rx: 1.77345,
    fill: "#EE4B63"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 83.7422,
    y: 131,
    width: 3.5469,
    height: 4.70646,
    rx: 1.77345,
    fill: "#EE4B63"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 83.7422,
    y: 200.775,
    width: 3.5469,
    height: 4.70646,
    rx: 1.77345,
    fill: "#EE4B63"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 83.7422,
    y: 154.258,
    width: 3.5469,
    height: 4.70646,
    rx: 1.77345,
    fill: "#EE4B63"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 83.7422,
    y: 224.035,
    width: 3.5469,
    height: 4.70646,
    rx: 1.77345,
    fill: "#EE4B63"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 83.7422,
    y: 177.518,
    width: 3.5469,
    height: 4.70646,
    rx: 1.77345,
    fill: "#EE4B63"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 83.7422,
    y: 247.293,
    width: 3.5469,
    height: 4.70646,
    rx: 1.77345,
    fill: "#EE4B63"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 154.969,
    y: 131,
    width: 3.5469,
    height: 4.70646,
    rx: 1.77345,
    fill: "#EE4B63"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 154.969,
    y: 200.775,
    width: 3.5469,
    height: 4.70646,
    rx: 1.77345,
    fill: "#EE4B63"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 154.969,
    y: 154.258,
    width: 3.5469,
    height: 4.70646,
    rx: 1.77345,
    fill: "#EE4B63"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 154.969,
    y: 224.035,
    width: 3.5469,
    height: 4.70646,
    rx: 1.77345,
    fill: "#EE4B63"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 154.969,
    y: 177.518,
    width: 3.5469,
    height: 4.70646,
    rx: 1.77345,
    fill: "#EE4B63"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 154.969,
    y: 247.293,
    width: 3.5469,
    height: 4.70646,
    rx: 1.77345,
    fill: "#EE4B63"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 202.453,
    y: 131,
    width: 3.5469,
    height: 4.70646,
    rx: 1.77345,
    fill: "#EE4B63"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 202.453,
    y: 200.775,
    width: 3.5469,
    height: 4.70646,
    rx: 1.77345,
    fill: "#EE4B63"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 202.453,
    y: 154.258,
    width: 3.5469,
    height: 4.70646,
    rx: 1.77345,
    fill: "#EE4B63"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 202.453,
    y: 224.035,
    width: 3.5469,
    height: 4.70646,
    rx: 1.77345,
    fill: "#EE4B63"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 202.453,
    y: 177.518,
    width: 3.5469,
    height: 4.70646,
    rx: 1.77345,
    fill: "#EE4B63"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 202.453,
    y: 247.293,
    width: 3.5469,
    height: 4.70646,
    rx: 1.77345,
    fill: "#EE4B63"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 107.484,
    y: 131,
    width: 3.5469,
    height: 4.70646,
    rx: 1.77345,
    fill: "#EE4B63"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 107.484,
    y: 200.775,
    width: 3.5469,
    height: 4.70646,
    rx: 1.77345,
    fill: "#EE4B63"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 107.484,
    y: 154.258,
    width: 3.5469,
    height: 4.70646,
    rx: 1.77345,
    fill: "#EE4B63"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 107.484,
    y: 224.035,
    width: 3.5469,
    height: 4.70646,
    rx: 1.77345,
    fill: "#EE4B63"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 107.484,
    y: 177.518,
    width: 3.5469,
    height: 4.70646,
    rx: 1.77345,
    fill: "#EE4B63"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 107.484,
    y: 247.293,
    width: 3.5469,
    height: 4.70646,
    rx: 1.77345,
    fill: "#EE4B63"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 178.711,
    y: 131,
    width: 3.5469,
    height: 4.70646,
    rx: 1.77345,
    fill: "#EE4B63"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 178.711,
    y: 200.775,
    width: 3.5469,
    height: 4.70646,
    rx: 1.77345,
    fill: "#EE4B63"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 178.711,
    y: 154.258,
    width: 3.5469,
    height: 4.70646,
    rx: 1.77345,
    fill: "#EE4B63"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 178.711,
    y: 224.035,
    width: 3.5469,
    height: 4.70646,
    rx: 1.77345,
    fill: "#EE4B63"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 178.711,
    y: 177.518,
    width: 3.5469,
    height: 4.70646,
    rx: 1.77345,
    fill: "#EE4B63"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 178.711,
    y: 247.293,
    width: 3.5469,
    height: 4.70646,
    rx: 1.77345,
    fill: "#EE4B63"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1021_1310",
    x: -294,
    y: 0,
    width: 708,
    height: 707,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 52,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1021_1310"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 21,
    dy: 16
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 58.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.549351 0 0 0 0 0.870833 0 0 0 0 0.774388 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1021_1310"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1021_1310",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1021_1310",
    x1: 39,
    y1: 153,
    x2: 39,
    y2: 522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAEFEF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomLeft);
export default __webpack_public_path__ + "static/media/bottomLeft.6d3ee3cb91379a3a91a02eb7ecf2b95a.svg";
export { ForwardRef as ReactComponent };